import { createTheme, type Theme } from '@mui/material/styles';

export interface BrandingThemeTokens {
  primaryColor?: string;
  secondaryColor?: string;
  successColor?: string;
  warningColor?: string;
  errorColor?: string;
  infoColor?: string;
}

/**
 * Build an MUI theme from mode + optional branding tokens.
 * No hardcoded hex values — all derived from tokens or MUI defaults.
 */
export function buildTheme(mode: 'light' | 'dark', tokens?: BrandingThemeTokens): Theme {
  return createTheme({
    palette: {
      mode,
      ...(tokens?.primaryColor && { primary: { main: tokens.primaryColor } }),
      ...(tokens?.secondaryColor && { secondary: { main: tokens.secondaryColor } }),
      ...(tokens?.successColor && { success: { main: tokens.successColor } }),
      ...(tokens?.warningColor && { warning: { main: tokens.warningColor } }),
      ...(tokens?.errorColor && { error: { main: tokens.errorColor } }),
      ...(tokens?.infoColor && { info: { main: tokens.infoColor } }),
    },
    typography: {
      fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif',
      fontSize: 14,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            margin: 0,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '0.813rem',
            '&:not(.MuiInputBase-multiline)': {
              height: 32,
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: '0.813rem',
            '&:not(.MuiInputLabel-shrink)': {
              transform: 'translate(14px, 5px) scale(1)',
            },
          },
          shrink: {
            fontSize: '0.75rem',
          },
        },
      },
    },
  });
}
